import type { LayoutOption } from '@ocktra/shared-types';

export const layoutPresets: LayoutOption[] = [
    {
        id: 'professional-trader',
        name: 'Professional Trader',
        description: 'Complete trading workspace',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="2" y="2" width="9" height="9" strokeWidth="2" rx="1" />
                <rect x="13" y="2" width="9" height="5" strokeWidth="2" rx="1" />
                <rect x="2" y="13" width="9" height="9" strokeWidth="2" rx="1" />
                <rect x="13" y="9" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="13" y="17" width="9" height="5" strokeWidth="2" rx="1" />
            </svg>
        ),
        cards: [
            { title: 'Chart', type: 'charts', position: { x: 0, y: 0 }, size: { width: 55, height: 70 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Market Watch', type: 'market', position: { x: 55, y: 0 }, size: { width: 45, height: 40 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Recent Trades', type: 'trades', position: { x: 0, y: 70 }, size: { width: 55, height: 30 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Portfolio Overview', type: 'portfolio', position: { x: 55, y: 40 }, size: { width: 45, height: 25 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Funds', type: 'funds', position: { x: 55, y: 65 }, size: { width: 45, height: 35 }, isMaximized: false, isMinimized: false, zIndex: 1 }
        ]
    },
    {
        id: 'market-focus',
        name: 'Market Focus',
        description: 'Large chart with side panels',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="2" y="2" width="14" height="20" strokeWidth="2" rx="1" />
                <rect x="18" y="2" width="4" height="9" strokeWidth="2" rx="1" />
                <rect x="18" y="13" width="4" height="9" strokeWidth="2" rx="1" />
            </svg>
        ),
        cards: [
            { title: 'Chart', type: 'charts', position: { x: 0, y: 0 }, size: { width: 70, height: 95 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Market Watch', type: 'market', position: { x: 70, y: 0 }, size: { width: 30, height: 47 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Market News', type: 'news', position: { x: 70, y: 48 }, size: { width: 30, height: 52 }, isMaximized: false, isMinimized: false, zIndex: 1 }
        ]
    },
    {
        id: 'triple-monitor',
        name: 'Triple Monitor',
        description: 'Three equal panels',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="2" y="4" width="6" height="16" strokeWidth="2" rx="1" />
                <rect x="9" y="4" width="6" height="16" strokeWidth="2" rx="1" />
                <rect x="16" y="4" width="6" height="16" strokeWidth="2" rx="1" />
            </svg>
        ),
        cards: [
            { title: 'Portfolio Overview', type: 'portfolio', position: { x: 0, y: 0 }, size: { width: 33, height: 100 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Market Watch', type: 'market', position: { x: 33, y: 0 }, size: { width: 33, height: 100 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Analytics', type: 'analytics', position: { x: 66, y: 0 }, size: { width: 34, height: 100 }, isMaximized: false, isMinimized: false, zIndex: 1 }
        ]
    },
    {
        id: 'grid-dashboard',
        name: 'Grid Dashboard',
        description: 'Balanced 2×3 grid',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="2" y="2" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="13" y="2" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="2" y="9" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="13" y="9" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="2" y="16" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="13" y="16" width="9" height="6" strokeWidth="2" rx="1" />
            </svg>
        ),
        cards: [
            { title: 'Portfolio Overview', type: 'portfolio', position: { x: 0, y: 0 }, size: { width: 50, height: 33 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Market Watch', type: 'market', position: { x: 50, y: 0 }, size: { width: 50, height: 33 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Recent Trades', type: 'trades', position: { x: 0, y: 33 }, size: { width: 50, height: 33 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Analytics', type: 'analytics', position: { x: 50, y: 33 }, size: { width: 50, height: 33 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Market News', type: 'news', position: { x: 50, y: 66 }, size: { width: 50, height: 34 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Stock Charts', type: 'charts', position: { x: 0, y: 66 }, size: { width: 50, height: 34 }, isMaximized: false, isMinimized: false, zIndex: 1 }
        ]
    },
    {
        id: 'analytics-heavy',
        name: 'Analytics Heavy',
        description: 'Multiple data panels',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="2" y="2" width="20" height="6" strokeWidth="2" rx="1" />
                <rect x="2" y="9" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="13" y="9" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="2" y="16" width="9" height="6" strokeWidth="2" rx="1" />
                <rect x="13" y="16" width="9" height="6" strokeWidth="2" rx="1" />
            </svg>
        ),
        cards: [
            { title: 'Portfolio Overview', type: 'portfolio', position: { x: 0, y: 0 }, size: { width: 100, height: 30 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Market Watch', type: 'market', position: { x: 0, y: 30 }, size: { width: 50, height: 35 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Analytics', type: 'analytics', position: { x: 50, y: 30 }, size: { width: 50, height: 35 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Recent Trades', type: 'trades', position: { x: 0, y: 65 }, size: { width: 50, height: 35 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Market News', type: 'news', position: { x: 50, y: 65 }, size: { width: 50, height: 35 }, isMaximized: false, isMinimized: false, zIndex: 1 }
        ]
    },
    {
        id: 'minimalist',
        name: 'Minimalist',
        description: 'Clean dual-panel layout',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="2" y="2" width="20" height="9" strokeWidth="2" rx="1" />
                <rect x="2" y="13" width="20" height="9" strokeWidth="2" rx="1" />
            </svg>
        ),
        cards: [
            { title: 'Market Watch', type: 'market', position: { x: 0, y: 0 }, size: { width: 100, height: 50 }, isMaximized: false, isMinimized: false, zIndex: 1 },
            { title: 'Portfolio Overview', type: 'portfolio', position: { x: 0, y: 50 }, size: { width: 100, height: 50 }, isMaximized: false, isMinimized: false, zIndex: 1 }
        ]
    }
];
